import { GlTooltipDirective, GlButton } from '../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
import { __ } from '~/locale';
export default {
    i18n: {
        buttonText: __('Reply to comment')
    },
    name: 'ReplyButton',
    components: {
        GlButton
    },
    directives: {
        GlTooltip: GlTooltipDirective
    },
    props: {
        ariaLabel: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'start-replying'
    ]
};
